import React, { useState } from 'react';
import { useSelector } from "react-redux";
import { t, findStringKeys } from '../common/LocalizationProvider';
import EditItemView from '../shared/EditItemView';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  makeStyles,
  Typography,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { prefixString, unprefixString } from '../common/stringUtils';
import SelectField from '../form/SelectField';
import { cyberStyles } from '../cssShared/cyberTheme';

const useStyles = makeStyles((theme) => ({
  ...cyberStyles(theme),
}));

const NotificationPage = () => {
  const classes = useStyles();
  const [item, setItem] = useState();
  useSelector(state => state.language.language);

  const alarms = findStringKeys(it => it.startsWith('alarm')).map(it => ({
    key: unprefixString('alarm', it),
    name: t(it),
  }));

  return (
      <EditItemView endpoint="notifications" item={item} setItem={setItem}>
        {item && (
            <>
              {/* SECTION 1: REQUIRED */}
              <Accordion defaultExpanded className={classes.accordion}>
                <AccordionSummary expandIcon={<ExpandMoreIcon style={{color: '#00f2ff'}} />}>
                  <Typography className={classes.summaryText}>
                    {t('sharedRequired')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <SelectField
                      margin="normal"
                      value={item.type}
                      onChange={e => setItem({...item, type: e.target.value})}
                      endpoint="/api/notifications/types"
                      keyGetter={it => it.type}
                      titleGetter={it => t(prefixString('event', it.type))}
                      label={t('sharedType')}
                      variant="filled"
                  />
                  <SelectField
                      multiple
                      margin="normal"
                      value={item.notificators ? item.notificators.split(/[, ]+/) : []}
                      onChange={e => setItem({...item, notificators: e.target.value.join()})}
                      endpoint="/api/notifications/notificators"
                      keyGetter={it => it.type}
                      titleGetter={it => t(prefixString('notificator', it.type))}
                      label={t('notificationNotificators')}
                      variant="filled"
                  />
                  {item.type === 'alarm' && (
                      <SelectField
                          multiple
                          margin="normal"
                          value={item.attributes && item.attributes.alarms ? item.attributes.alarms.split(/[, ]+/) : []}
                          onChange={e => setItem({...item, attributes: {...item.attributes, alarms: e.target.value.join()}})}
                          data={alarms}
                          keyGetter={it => it.key}
                          label={t('sharedAlarms')}
                          variant="filled"
                      />
                  )}
                  <FormControlLabel
                      className={classes.checkboxLabel}
                      control={
                        <Checkbox
                            checked={item.always}
                            onChange={event => setItem({...item, always: event.target.checked})}
                        />
                      }
                      label={t('allDevices')}
                  />
                </AccordionDetails>
              </Accordion>
            </>
        )}
      </EditItemView>
  );
}

export default NotificationPage;